import { render, staticRenderFns } from "./BlackFriday24.vue?vue&type=template&id=65d6732c&"
import script from "./BlackFriday24.vue?vue&type=script&lang=js&"
export * from "./BlackFriday24.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/sections/modal-register.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports